import memoize from "memoize-one"
export { memoize as memoizeOne }
